var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_5359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 0.75H1.75C1.35218 0.75 0.970644 0.908035 0.68934 1.18934C0.408035 1.47064 0.25 1.85218 0.25 2.25V15.75C0.25 16.1478 0.408035 16.5294 0.68934 16.8107C0.970644 17.092 1.35218 17.25 1.75 17.25H18.25C18.6478 17.25 19.0294 17.092 19.3107 16.8107C19.592 16.5294 19.75 16.1478 19.75 15.75V2.25C19.75 1.85218 19.592 1.47064 19.3107 1.18934C19.0294 0.908035 18.6478 0.75 18.25 0.75ZM12.625 5.25C12.8475 5.25 13.065 5.31598 13.25 5.4396C13.435 5.56321 13.5792 5.73891 13.6644 5.94448C13.7495 6.15005 13.7718 6.37625 13.7284 6.59448C13.685 6.81271 13.5778 7.01316 13.4205 7.1705C13.2632 7.32783 13.0627 7.43498 12.8445 7.47838C12.6262 7.52179 12.4 7.49951 12.1945 7.41436C11.9889 7.32922 11.8132 7.18502 11.6896 7.00002C11.566 6.81501 11.5 6.5975 11.5 6.375C11.5 6.07663 11.6185 5.79048 11.8295 5.5795C12.0405 5.36853 12.3266 5.25 12.625 5.25ZM18.25 15.75H1.75V12.0647L6.09437 7.71937C6.16403 7.64964 6.24675 7.59432 6.33779 7.55658C6.42884 7.51884 6.52644 7.49941 6.625 7.49941C6.72356 7.49941 6.82116 7.51884 6.91221 7.55658C7.00325 7.59432 7.08597 7.64964 7.15563 7.71937L13.4688 14.0306C13.6095 14.1714 13.8004 14.2504 13.9994 14.2504C14.1984 14.2504 14.3893 14.1714 14.53 14.0306C14.6707 13.8899 14.7498 13.699 14.7498 13.5C14.7498 13.301 14.6707 13.1101 14.53 12.9694L12.8744 11.3147L14.2188 9.96937C14.3594 9.82883 14.5501 9.74988 14.7489 9.74988C14.9477 9.74988 15.1384 9.82883 15.2791 9.96937L18.25 12.9441V15.75Z",
    fill: "#262626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_5359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.9e82d1eaea83d759535817f3131e9d0d.svg";
export { ForwardRef as ReactComponent };